var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.value}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.value}},[_vm._v(_vm._s(option.html))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72709506","hasScoped":false}!../node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/styleguide/components/HtmlCapableSelectBox.vue
// module id = null
// module chunks = 